/* eslint-disable no-unused-vars */
export const enum PrimaryRoutes {
	Home = '/dashboard',
	AIAnalyst = '/ai-analyst',
	AIAnalystConversation = '/ai-analyst/:conversationId',
	Contacts = '/contacts',
	ContactDetails = '/contacts/:contactId',
	Campaigns = '/campaigns',
	CXInsights = '/cx-insights',
	DataInsights = '/sales-insights',
	Help = '/help',
	OpsInsights = '/ops-insights',
	CRMInsights = '/crm-insights',
	ProfitInsights = '/profit-insights',
	D2CDashboard = '/d2c-dashboard',
	RetailDashboard = '/retail-dashboard',
	ConversionInsights = '/conversion-insights',
	ProductInsights = '/product-insights',
	Acquisition = '/acquisition',
	Retention = '/retention',
	Subscription = '/subscription',
	Customer = '/customer',
	Settings = '/settings',
	SegmentBuilder = '/segments/builder',
	SegmentBuilderDetails = '/segments/builder/:segmentId',
	Segments = '/segments',
	ExportCleaner = '/export-cleaner',
	CACSignals = '/cac-signals',
	LTVSignals = '/ltv-signals',
	ConversionSignals = '/conversion-signals',
	ExperienceSignals = '/experience-signals',
	PerformanceSignals = '/performance-signals',
	GrowthModel = '/growth-model',
	JourneyExplorer = '/journey-explorer',
}
